import { useTranslation } from 'next-i18next';
import { Box } from '@bridebook/ui';
import { IconStar } from '@bridebook/ui/src/icons/dynamic';
import AppBadge from '@bridebook/web/app-shared/components/app-badge/app-badge';
import componentStyles from '@bridebook/web/app-shared/components/articles/app-ad/app-ad.style';
import { useMarket } from '@bridebook/web/app-shared/lib/i18n/hooks/use-market';
import { IMAGES_BASE_URL } from '@bridebook/toolbox/src/buildImageUrl';
import { Button, Text, Flex } from '@bridebook/aura';
import SignupLink from '@bridebook/web/app-shared/components/signup-link/signup-link';

interface IProps {
  isListView?: boolean;
}

const AppAdComponent = ({ isListView }: IProps) => {
  const { t } = useTranslation('articles');
  const market = useMarket();
  const styles = componentStyles();
  const stars = [1, 2, 3, 4, 5] as number[];
  return (
    <Box style={styles.adWrapper(isListView)}>
      {isListView ? (
        <Flex className="w-full flex-col items-center text-center">
          <Text className="mb-2 typo-lg-semibold">{t('appBanner.title')}</Text>
          <Text className="mx-2 mb-4 typo-sm">{t('appBanner.details')}</Text>
          <SignupLink>
            <Button>{t('get.app')}</Button>
          </SignupLink>
        </Flex>
      ) : (
        <Box style={styles.adTitle}>{t('download.ad')}</Box>
      )}
      <Box style={styles.imgWrapper}>
        <img style={styles.img} src={`${IMAGES_BASE_URL}/assets/article/main_banner.png`} alt="" />
        {market && <AppBadge market={market} />}
      </Box>
      <Box style={styles.reviewContainer}>
        <Box flexDirection="row" gap={1}>
          {stars.map((index) => (
            <IconStar
              color={isListView ? 'peachRose120' : undefined}
              key={`icon-star-${index}`}
              width={20}
            />
          ))}
        </Box>
        <Box style={styles.reviewsAmount}>{t('7.7thousand')}</Box>
      </Box>
    </Box>
  );
};

export default AppAdComponent;
